<template>
<div>
    <!-- loading -->
	<img v-if="checkCached(imageUrl)" class="thumbnail-gallery" :src="imageUrl">
    <clazy-load v-if="!checkCached(imageUrl)" class="thumbnail-gallery" :src="imageUrl">
        <!-- The image slot renders after the image loads. -->
        <img class="thumbnail-gallery" :src="imageUrl">
        <!-- The placeholder slot displays while the image is loading. -->
        <div slot="placeholder">
            <!-- You can put any component you want in here. -->
				<!-- <content-loader
					class="thumbnail-gallery"
					:width="90"
					:height="90"
					:speed="1"
					primaryColor="#292929"
					secondaryColor="#191919B3" >
					<rect x="0" y="0" rx="2" ry="2" width="90" height="90" />
				</content-loader> -->
				<img class="thumbnail-gallery" :src="'/img/Rolling-1s-90px.svg'">
        </div>
    </clazy-load>
</div>
</template>

<script>
import localforage from 'localforage';
import axios from 'axios';
// import SkeletonLoader from '@/components/SkeletonLoader.vue';
// import { ContentLoader } from 'vue-content-loader';

export default {

	name: 'GalleryPopupImageThumbnail',
	props: {
		media: {
			type: Object,
		},
	},
	components: {
		// SkeletonLoader,
		// ContentLoader,
	},
	data() {
		return {
			mediaSource: '',
			thumbnailNotFound: false,
		};
	},
	created() {
		this.asyncgetMediaSource();
	},
	methods: {
		asyncgetMediaSource() {
			const itemKey = `thumbnail_${this.media.id}`;
			this.mediaSource = this.media && this.media.thumbnail ? this.media.thumbnail : this.media.path;
			localforage.getItem(itemKey).then((value) => {
				if (value) {
					this.mediaSource = URL.createObjectURL(value);
					return (this.mediaSource);
				}
				this.checkUrl();
				return (this.mediaSource);
			});
		},
		checkCached(imgUrl) {
			const thumbnail = this.media && this.media.thumbnail ? this.media.thumbnail : this.media.path;
			if (imgUrl === thumbnail) return false;
			return true;
		},
		async checkUrl() {
			try {
				await axios.get(this.media.thumbnail || this.media.path);
				this.thumbnailNotFound = false;
			} catch (error) {
				this.thumbnailNotFound = true;
				if (this.thumbnailNotFound) this.mediaSource = '/img/TemplateThumbnailDefault_01.jpg';
			}
		},
	},
	computed: {
		imageUrl() {
			return (this.mediaSource);
		},
	},
	watch: {
		async media() {
			this.asyncgetMediaSource();
		},
	},
};
</script>
